import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context('.', true, /[A-Z,a-z]\w+\.vue$/)

requireComponent.keys().map(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName.split('/')[2].replace(/.vue/, '')
    )
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})



// WEBPACK FOOTER //
// ./src/components/_globals.js